import { render } from "./apps.vue?vue&type=template&id=94b34fac&scoped=true"
import script from "./apps.vue?vue&type=script&lang=js"
export * from "./apps.vue?vue&type=script&lang=js"

import "./apps.vue?vue&type=style&index=0&id=94b34fac&scoped=true&lang=css"
import "./apps.vue?vue&type=style&index=1&id=94b34fac&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-94b34fac"]])

export default __exports__